
import { Component, Prop, Vue } from "vue-property-decorator";
import DefaultChart from "@/components/dashboard/widgets/DefaultChart.vue";
import WidgetData from "@/interfaces/dashboard/WidgetData";

@Component({
  components: {
    DefaultChart,
  },
})
export default class ChartBar extends Vue {
  @Prop({ default: {} })
  public widgetData: WidgetData;
}
